// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.material-design-icon[data-v-018e1c98] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.team-resources__header[data-v-018e1c98] {
  font-weight: 700;
  margin-bottom: 6px;
}
.related-team[data-v-018e1c98] {
  border-radius: var(--border-radius-rounded);
  border: 2px solid var(--color-border-dark);
  margin-bottom: 6px;
}
.related-team__open[data-v-018e1c98] {
  border-color: var(--color-primary-element);
}
.related-team__header[data-v-018e1c98] {
  padding: 6px 24px 6px 6px;
  display: flex;
  gap: 12px;
}
.related-team__name[data-v-018e1c98] {
  display: flex;
  flex-grow: 1;
  align-items: center;
  gap: 12px;
  padding: 6px 12px;
  font-weight: 700;
  margin: 0;
}
.related-team .related-team-provider[data-v-018e1c98] {
  padding: 6px 12px;
}
.related-team .related-team-provider__name[data-v-018e1c98] {
  font-weight: 700;
  margin-bottom: 3px;
}
.related-team .related-team-provider__link[data-v-018e1c98] {
  display: flex;
  gap: 12px;
  padding: 6px 12px;
  font-weight: 700;
}
.related-team .related-team-resource__link[data-v-018e1c98] {
  display: flex;
  gap: 12px;
  height: 44px;
  align-items: center;
  border-radius: var(--border-radius-large);
}
.related-team .related-team-resource__link[data-v-018e1c98]:hover {
  background-color: var(--color-background-hover);
}
.related-team .related-team-resource__link[data-v-018e1c98]:focus {
  background-color: var(--color-background-hover);
  outline: 2px solid var(--color-primary-element);
}
.related-team .related-team-resource .resource__icon[data-v-018e1c98] {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.related-team .related-team-resource .resource__icon > img[data-v-018e1c98] {
  border-radius: var(--border-radius-pill);
  overflow: hidden;
  width: 32px;
  height: 32px;
}
.material-design-icon[data-v-dd53e5b9] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.resource[data-v-dd53e5b9] {
  display: flex;
  align-items: center;
  height: 44px;
}
.resource__button[data-v-dd53e5b9] {
  width: 100% !important;
  justify-content: flex-start !important;
  padding: 0 !important;
}
.resource__button[data-v-dd53e5b9] .button-vue__wrapper {
  justify-content: flex-start !important;
}
.resource__button[data-v-dd53e5b9] .button-vue__wrapper .button-vue__text {
  font-weight: 400 !important;
  margin-left: 2px !important;
}
.resource__icon[data-v-dd53e5b9] {
  width: 32px;
  height: 32px;
  background-color: var(--color-text-maxcontrast);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.resource__icon img[data-v-dd53e5b9] {
  width: 16px;
  height: 16px;
  filter: var(--background-invert-if-dark);
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-8855c164] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.related-resources__header h5[data-v-8855c164] {
  font-weight: 700;
  margin-bottom: 6px;
}
.related-resources__header p[data-v-8855c164] {
  color: var(--color-text-maxcontrast);
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcRelatedResourcesPanel-D6K7OQFJ.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;EAC/C,+CAA+C;AACjD;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,qBAAqB;AACvB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;AAC1C;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC","sourcesContent":["@charset \"UTF-8\";\n.material-design-icon[data-v-018e1c98] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.team-resources__header[data-v-018e1c98] {\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n.related-team[data-v-018e1c98] {\n  border-radius: var(--border-radius-rounded);\n  border: 2px solid var(--color-border-dark);\n  margin-bottom: 6px;\n}\n.related-team__open[data-v-018e1c98] {\n  border-color: var(--color-primary-element);\n}\n.related-team__header[data-v-018e1c98] {\n  padding: 6px 24px 6px 6px;\n  display: flex;\n  gap: 12px;\n}\n.related-team__name[data-v-018e1c98] {\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n  gap: 12px;\n  padding: 6px 12px;\n  font-weight: 700;\n  margin: 0;\n}\n.related-team .related-team-provider[data-v-018e1c98] {\n  padding: 6px 12px;\n}\n.related-team .related-team-provider__name[data-v-018e1c98] {\n  font-weight: 700;\n  margin-bottom: 3px;\n}\n.related-team .related-team-provider__link[data-v-018e1c98] {\n  display: flex;\n  gap: 12px;\n  padding: 6px 12px;\n  font-weight: 700;\n}\n.related-team .related-team-resource__link[data-v-018e1c98] {\n  display: flex;\n  gap: 12px;\n  height: 44px;\n  align-items: center;\n  border-radius: var(--border-radius-large);\n}\n.related-team .related-team-resource__link[data-v-018e1c98]:hover {\n  background-color: var(--color-background-hover);\n}\n.related-team .related-team-resource__link[data-v-018e1c98]:focus {\n  background-color: var(--color-background-hover);\n  outline: 2px solid var(--color-primary-element);\n}\n.related-team .related-team-resource .resource__icon[data-v-018e1c98] {\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n.related-team .related-team-resource .resource__icon > img[data-v-018e1c98] {\n  border-radius: var(--border-radius-pill);\n  overflow: hidden;\n  width: 32px;\n  height: 32px;\n}\n.material-design-icon[data-v-dd53e5b9] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.resource[data-v-dd53e5b9] {\n  display: flex;\n  align-items: center;\n  height: 44px;\n}\n.resource__button[data-v-dd53e5b9] {\n  width: 100% !important;\n  justify-content: flex-start !important;\n  padding: 0 !important;\n}\n.resource__button[data-v-dd53e5b9] .button-vue__wrapper {\n  justify-content: flex-start !important;\n}\n.resource__button[data-v-dd53e5b9] .button-vue__wrapper .button-vue__text {\n  font-weight: 400 !important;\n  margin-left: 2px !important;\n}\n.resource__icon[data-v-dd53e5b9] {\n  width: 32px;\n  height: 32px;\n  background-color: var(--color-text-maxcontrast);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.resource__icon img[data-v-dd53e5b9] {\n  width: 16px;\n  height: 16px;\n  filter: var(--background-invert-if-dark);\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-8855c164] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.related-resources__header h5[data-v-8855c164] {\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n.related-resources__header p[data-v-8855c164] {\n  color: var(--color-text-maxcontrast);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
